module.exports = __webpack_public_path__ + "img/tj.bc17f365.svg";